module.exports = __webpack_public_path__ + "static/media/cullen.9d052de6.png";